// START AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel
import { AbTest } from 'abTests/lib/AbTest';

const HomePageContinuousScrollSettings = CBS?.AbTestsConfigs?.modules?.HomePageContinuousScroll;
export default class HomePageContinuousScroll extends AbTest {
    constructor(swiper) {
        super(HomePageContinuousScrollSettings);
        this.swiper = swiper;
        this.implement();
        this.slides = [];
        this.carouselCycle = 0;
        this.setInitialCarouselCycle();
    }

    //store slides
    setSlides() {
        if (this.slides.length === 0) {
            for (const slide of this.swiper.virtual.slides) {
                this.slides.push(slide);
            }
        }
    }

    setInitialCarouselCycle() {
        if (this.carouselCycle === 0) {
            for (let j = 0; j < this.swiper.slides.length; j++) {
                const link = this.swiper.slides[j].querySelector('a.link');
                link.setAttribute('data-cycle', this.carouselCycle);
            }
        }
    }

    /**
     * generic function that check if carousel has reached to end.
     */
    hasSwiperReachEnd() {
        return this.swiper.slides.length > this.swiper.params.slidesPerGroup && this.swiper.isEnd;
    }

    /**
     * only append slides when carousel is end and dont have next buffer.
     * @return void
     */
    appendInfiniteSlides() {
        if (this.hasSwiperReachEnd()) {
            if (this.slides.length === 0) {
                this.setSlides();
            }

            this.carouselCycle++;
            this.setCarouselCycle();

            setTimeout(() => {
                this.lazyLoadImages();
                this.swiper.virtual.appendSlide(this.slides);
            }, 300);
        }
    }

    setCarouselCycle() {
        for (let i = 0; i < this.slides.length; i++) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = this.slides[i];
            const link = wrapper.querySelector('a.link');
            link.setAttribute('data-cycle', this.carouselCycle);
            this.slides[i] = wrapper.innerHTML;
        }
    }

    lazyLoadImages() {
        if (CBS.Registry.lazyImage) {
            setTimeout(CBS.Registry.lazyImage.revalidate, 5);
        }
    }

    getCarouselCycle(tile) {
        return tile.getAttribute('data-cycle') ?? 0;
    }
}

export const allowContinuousScroll = (wrapper) => {
    const ENDLESS_SCROLL = 'endless_scroll';

    if (CBS?.AbTestsConfigs?.modules?.HomePageContinuousScroll?.activeVariant === ENDLESS_SCROLL) {
        const KEEP_WATCHING = 'keep-watching';
        const MY_LIST = 'my-list';
        const EXCLUDED_CAROUSELS = [KEEP_WATCHING, MY_LIST];
        const isCarouselAllowEndlessScroll = () => {
            const CAROUSEL_ID = wrapper.getAttribute('id');
            return !EXCLUDED_CAROUSELS.includes(CAROUSEL_ID);
        };
        return isCarouselAllowEndlessScroll();
    }

    return false;
};

// END AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel
